import React from "react";
import Input from "@/components/forms/Input";

const INPUT_CLASS = "h-7 text-xs px-1 w-full text-center bg-white";

interface MinMaxInputProps {
    min: number;
    max: number;
    disabled?: boolean;
    onChange: (patch: { min?: number; max?: number }) => void;
}

export default function MinMaxInput({ min, max, disabled = false, onChange }: Readonly<MinMaxInputProps>) {
    const handle = (field: "min" | "max", raw: string) => {
        const n = Number.parseInt(raw, 10);
        const value = Number.isNaN(n) ? 0 : Math.max(0, n);
        onChange(field === "min" ? { min: value } : { max: value });
    };

    return (
        <div className="flex items-center gap-1">
            <Input
                type="number"
                min={0}
                value={min}
                disabled={disabled}
                onChange={(e) => handle("min", e.target.value)}
                className={INPUT_CLASS}
                aria-label="Besoin minimum"
            />
            <span> vs </span>
            <Input
                type="number"
                min={0}
                value={max}
                disabled={disabled}
                onChange={(e) => handle("max", e.target.value)}
                className={INPUT_CLASS}
                aria-label="Besoin idéal"
            />
        </div>
    );
}
